export default class IntlTelInputElement extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const input = this.querySelector('input[type=text]');
        window.intlTelInput(input, {
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
            initialCountry: 'auto',
            separateDialCode: true,
            hiddenInput: this.getAttribute('hidden-input'),
            geoIpLookup: function(callback) {
                fetch('https://ipapi.co/json')
                .then(function(res) { return res.json(); })
                .then(function(data) { callback(data.country_code); })
                .catch(function() { callback('us'); });
            }
        });
    }
};
window.customElements.define('intl-tel-input', IntlTelInputElement);